import moment from "moment-timezone"

export const formatInboundCsvDate = (
    dateString?: string,
    timezone: string | undefined = "UTC",
): string | undefined => {
    if (!dateString || !timezone) {
        return undefined
    }
    return moment(dateString).tz(timezone).format("YYYY-MM-DD")
}

export const formatInboundCsvTime = (
    dateString?: string,
    timezone: string | undefined = "UTC",
): string | undefined => {
    if (!dateString || !timezone) {
        return undefined
    }
    return moment(dateString).tz(timezone).format("HH:mm")
}

export const formatInboundCsvDateAndTime = (
    dateString?: string,
    timezone: string | undefined = "UTC",
): string | undefined => {
    if (!dateString || !timezone) {
        return undefined
    }
    return moment(dateString).tz(timezone).format("YYYY-MM-DD HH:mm")
}

export const formatInboundCsvValue = (value: unknown): unknown =>
    typeof value === "number"
        ? value.toLocaleString("en-US", {
            maximumFractionDigits: 5,
            useGrouping: false,
        })
        : value
